import * as React from 'react';
import Helmet from 'react-helmet';
import { css } from 'aphrodite/no-important';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { MandatoryAdditionalStyle } from '../../components.utils';

interface CerosDataProps {
    html: string;
    dataId?: string;
}

export interface IframeThemeProps {
    backgroundColor: string;
}

type CerosProps = CerosDataProps & MandatoryAdditionalStyle;

export const Ceros: React.FunctionComponent<CerosProps> = props => {
  const { html, additionalStyle, dataId } = props;
  return (
    <ErrorBoundary>
      <Helmet>
        <script async defer src="https://static.apester.com/js/sdk/latest/apester-sdk.js" />
      </Helmet>
      <div className={css(additionalStyle.style)}>
        {/* eslint-disable-next-line react/no-danger */}
        <figure data-id={dataId} dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </ErrorBoundary>
  );
};
